module.exports = __webpack_public_path__ + "img/img-2.86646f7d.jpeg";